import { useNavigate } from 'react-router-dom';
import ComingSoon from '../../../commonComponent/ComingSoon';

function MenuPricingPromotions() {
  const navigate = useNavigate();
  return (
    <div className="p-6 bg-gray-100 min-h-screen flex flex-col">
      <header className="flex justify-between items-center mb-3 bg-white p-3">
        <h1 className="text-black text-xl font-bold ml-2">Menu Management</h1>
        <div className="flex space-x-6">
          <button onClick={() => navigate('/dashboard/mdm/menu-items-managment')} className="btn">
            Menu Items Management
          </button>
          <button onClick={() => navigate('/dashboard/mdm/menu-Categorization')} className="btn ">
            Menu Categorization
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/menu-pricing-promotions')}
            className="btn text-black font-bold"
          >
            Menu Pricing & Promotions
          </button>
          <button
            onClick={() => navigate('/dashboard/mdm/menu-analytics-insights')}
            className="btn "
          >
            Menu Analytics & Insights
          </button>
        </div>
      </header>

      <div className="text-center mb-2">
        <ComingSoon />
      </div>
    </div>
  );
}

export default MenuPricingPromotions;
